export enum NodeEnvironment {
  Development = 'development',
  Production = 'production',
}
